import { createContext, useContext, useState, ReactNode } from 'react';
import { ChatMessage } from '@/lib/chatService';

interface FloatingChatContextType {
  isOpen: boolean;
  isMinimized: boolean;
  messages: ChatMessage[];
  hasUnreadMessages: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setIsMinimized: (isMinimized: boolean) => void;
  setMessages: (messages: ChatMessage[] | ((prev: ChatMessage[]) => ChatMessage[])) => void;
  setHasUnreadMessages: (hasUnread: boolean) => void;
}

const FloatingChatContext = createContext<FloatingChatContextType | undefined>(undefined);

export const FloatingChatProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);

  return (
    <FloatingChatContext.Provider
      value={{
        isOpen,
        isMinimized,
        messages,
        hasUnreadMessages,
        setIsOpen,
        setIsMinimized,
        setMessages,
        setHasUnreadMessages,
      }}
    >
      {children}
    </FloatingChatContext.Provider>
  );
};

export const useFloatingChat = () => {
  const context = useContext(FloatingChatContext);
  if (!context) {
    throw new Error('useFloatingChat must be used within FloatingChatProvider');
  }
  return context;
};
